import React from 'react'
import { RadioGroup } from '~/shadcn/ui/radio-group'

type Value = {
  score?: number
  value?: string
}

type Props = Omit<
  React.ComponentProps<typeof RadioGroup>,
  'value' | 'onValueChange'
> & {
  value?: Value
  onValueChange(value: Value): void
}

export function ScoreRadioGroup(props: Props) {
  return (
    <RadioGroup
      {...props}
      className="gap-4 items-start"
      value={props.value?.value || ''}
      onValueChange={(value: string) => {
        const label = document.querySelector(
          `label[data-value="${value}"]`
        ) as HTMLElement | null
        const score = label?.getAttribute('data-score')
        props.onValueChange({
          value,
          score: Number(score || 0),
        })
      }}
    />
  )
}
